import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet';
import ListOfCommissionedJobs from "../components/ListOfCommissionedJobs";


class CommissionedIndexPage extends React.Component {

    constructor(props) {
        super(props);
        this.state ={
            jobs : this.props.data.allMarkdownRemark.edges.map(edge => edge.node.frontmatter)
        }
    }

    render() {
        return (
            <section className="section body section-content-wrapper">
                <Helmet
                    title="Commissioned"
                    bodyAttributes={{
                        class: "page-commissioned-index theme-pink"
                    }}/>

                <div className="jobs">
                    <ListOfCommissionedJobs jobs={this.state.jobs} />
                </div>

            </section>

        );
    }
}

CommissionedIndexPage.propTypes = {
    data: PropTypes.object
}
export default CommissionedIndexPage;

export const commissionedIndexPageQuery = graphql`
  query CommissionedIndexPage{
    allMarkdownRemark(filter: {frontmatter: {type: {eq: "commissioned"}}}, sort: {fields: [frontmatter___order], order: ASC}) {
      edges {
        node {
          id
          frontmatter {
            order
            title
            path
            mainImageUrl
            hoverImageUrl
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/commissioned-index-page.js